import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { PracticeDTO } from 'src/app/shared/proxies';
import { APP_VERSION } from 'src/version';

@Component({
    selector: 'add-main-practice',
    templateUrl: './main-practice.component.html',
    styleUrls: ['./main-practice.component.scss'],
})
export class MainPracticeComponent implements OnInit {
    version: string;
    practice: PracticeDTO;

    constructor(public authService: AuthService, private route: ActivatedRoute) {
        this.version = APP_VERSION.version;
    }

    ngOnInit(): void {
        this.route.data.subscribe((data) => {
            this.practice = data.practice as PracticeDTO;
        });
    }
}
